import {useQuery, type UseQueryResult} from '@tanstack/react-query'

import {ApplicationBypassData} from 'interfaces'
import {PoliciesService} from 'services/api'

export const GET_APPLICATION_BYPASS_RESOURCE_QUERY_KEY =
  'getApplicationBypassResourceData'

export const getApplicationBypassResourceQueryKey = (
  policyName: string,
): readonly [typeof GET_APPLICATION_BYPASS_RESOURCE_QUERY_KEY, string] => [
  GET_APPLICATION_BYPASS_RESOURCE_QUERY_KEY,
  policyName,
]

interface GetApplicationBypassResourceQueryProps {
  policyName: string
  enabled?: boolean
}

export const useGetApplicationBypassResource = ({
  policyName,
  enabled = true,
}: GetApplicationBypassResourceQueryProps): UseQueryResult<ApplicationBypassData> =>
  useQuery({
    queryKey: getApplicationBypassResourceQueryKey(policyName),
    queryFn: () => PoliciesService.getApplicationBypass(policyName),
    select: ({data}): ApplicationBypassData => data,
    enabled,
    refetchOnWindowFocus: false,
  })
